import { render, staticRenderFns } from "./AiWorkforceHome.vue?vue&type=template&id=1af65616&scoped=true"
import script from "./AiWorkforceHome.vue?vue&type=script&lang=js"
export * from "./AiWorkforceHome.vue?vue&type=script&lang=js"
import style0 from "./AiWorkforceHome.vue?vue&type=style&index=0&id=1af65616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af65616",
  null
  
)

export default component.exports